<header class="vc-admin-table-toolbar">
  <div class="vc-admin-table-toolbar__meta">
    @if (titleKey) {
      <h3 class="vc-admin-table-toolbar__title">{{ titleKey | translate }}</h3>
    }

    @if (descriptionKey) {
      <p class="vc-admin-table-toolbar__description">{{ descriptionKey | translate }}</p>
    }
  </div>

  <div class="vc-admin-table-toolbar__controls">
    @if (showSearch) {
      <label class="vc-admin-table-toolbar__search" aria-label="Search">
        <i class="fas fa-search" aria-hidden="true"></i>
        <input
          class="vc-admin-table-toolbar__search-input"
          pInputText
          type="text"
          [value]="searchValue"
          [placeholder]="searchPlaceholderKey | translate"
          (input)="onSearchInput($any($event.target).value)"
        />
      </label>
    }

    <div class="vc-admin-table-toolbar__actions">
      <ng-content select="[toolbar-actions]"></ng-content>
    </div>
  </div>
</header>
